import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const ModalContainer = styled.div`
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
    background-color: ${colourScheme.primaryLight};
    text-align: center;
    align-items: center;
    border-radius: 0.5rem;
    max-width: 26rem;
    & > hr {
        width: 100%;
        color: ${colourScheme.white};
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: center;
`;

export const GoldCost = styled.span`
    color: gold;
    font-size: 0.9em;
    margin-left: 0.5rem;
`;

export const SliderWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;

    input[type="range"] {
        flex: 1;
    }

    input[type="number"] {
        width: 4rem;
    }
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    ${device.md} {
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
    }
`;

export const Icon = styled.div`
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 1.5rem;
    width: 1.5rem;
    cursor: pointer;
    position: relative;
    margin-left: 0.2rem;
    svg,
    img {
        opacity: 0.5;
        height: 100%;
        width: 100%;
    }
    & > span {
        padding: 0.25rem;
        color: ${colourScheme.secondary};
    }
`;

export const FormGroup = styled.div`
    display: flex;
    align-items: stretch;
    flex-direction: column;
    ${device.md} {
        flex-direction: row;
    }
    ${device.lg} {
        flex-direction: column;
    }
    gap: 0.5rem;
`;
